<template>
	<div id="workbenchBox" ref='workBox' v-loading="loading">
		<div class="workbenchBox">
			<div class="left">
				<div class="top" ref='workBoxTop' >
					<div class="left">案件工作台</div>
					<div class="right" @click="outerVisible=true"> <i class="el-icon-plus"></i> 添加联系人</div>
				</div>
				<div class="group" v-if='isGroup'>
					<ul>
						<li v-for="item in userList">
							<img :src="item.portrait || imgUrl">
							<p>{{item.name}}</p>
						</li>
					</ul>
				</div>
				<div class="header_box innerbox" ref=messageBox :style="{height:isGroup?'500px':'580px'}">
					<ul class="messageBox">
						<li class="overflow" v-for="(item,index) in messageList" :class="{myself:item.data.who == 'myself'}">
							<img v-if="item.data.who == 'himself'" class="left icon" src="./img/moren.png">
							<div class="message left">
								<p class="text1">{{item.data.name}} <span>{{timeFormatting(item.sendTime)}}</span></p>
								<p class="text2" v-if="item.data.message.content">{{item.data.message.content}}</p>
								<img @click="imgFun(item.data.message.picUrl)" class="messImg" v-if="item.data.message.picUrl" :src="item.data.message.picUrl">
								<voiceBox v-if="item.data.message.url" :voiceUrl='item.data.message.url' :who='item.data.who'></voiceBox>
							</div>
							<img v-if="item.data.who == 'myself'" class="left icon" src="./img/moren.png">
						</li>
					</ul>
				</div>
				<div class="enterBox overflow">
					<input class="left" type="text" :placeholder="langtrans().qsr[languageIndex]" v-model="messageText"  @keyup="enterFun($event)"/>
					<button class="left" type="button" @click="websocketSendText">{{langtrans().ffs[languageIndex]}}</button>
				</div>
			</div>
			<div class="right">
				<p class="top" @click="closeFun"><i class="el-icon-close"> </i> 关闭聊天</p>
				<div class="headerBox innerbox listBoxHover">
					<ul class="listBox" v-if="localStoragePeople.length != 0">
						<div>
							<p>最近联系人</p>
						</div>
						<li v-for="(item,index) in localStoragePeople" :class="{active:caseUserId == item.id && caseUserIndex == index}" v-if="item.typeUser == 'user'" @click="checkFun(item.id,index,item.typeUser)">
							<img :src="item.portrait || imgUrl">
							<p :title="item.name">{{item.name}}</p>
						</li>
						<li v-for="(item,index) in localStoragePeople" :class="{active:caseUserId == item.id && caseUserIndex == index}" v-if="item.typeUser == 'group'" @click="checkFun(item.groupId,index,item.typeUser)">
							<img :src="item.portrait || imgUrl">
							<p :title="item.name">{{item.name}}</p>
						</li>
					</ul>
					<ul class="listBox">
						<div>
							<p>指挥中心</p>
						</div>
						<li v-for="(item,index) in getZhzxData" :class="{active:caseUserId == item.id && caseUserIndex == index}" @click="checkFun(item.id,index,'user',item)">
							<img :src="item.portrait || imgUrl">
							<p>{{item.realName}}</p>
							<span v-if="item.txtNum">{{item.txtNum}}</span>
						</li>
					</ul>
					<template v-for="(item,index) in getUserData">
						<ul class="listBox">
							<div class="iconGroup">
								<p :title="item.rescueCase.reportUser">{{item.rescueCase.reportUser}}{{item.rescueCase.id}} 案件</p>
								<!-- <i class="geren" @click="outerVisible=true;creatGroup(item.rescueCase.id,true)">1</i> -->
								<img src="./img/geren.png" alt="" @click="outerVisible=true;creatGroup(item.rescueCase.id,true)">
								<img src="./img/qun.png" @click="outerVisible=true;creatGroup(item.rescueCase.id)">
								<!-- <i class="el-icon-circle-plus-outline" @click="outerVisible=true;creatGroup(item.rescueCase.id)">2</i> -->
							</div>
							<li v-for="(item1,index1) in item.imGroups" :class="{active:caseUserId == item1.groupId && caseUserIndex == index}" @click="checkFun(item1.groupId,index,'group',item1)">
								<img :src="imgUrl1">
								<p :title="item1.name">{{item1.name}}</p>
								<span v-if="item1.txtNum">{{item1.txtNum}}</span>
							</li>
							<li v-for="(item1,index1) in item.users" :class="{active:caseUserId == item1.id && caseUserIndex == index}" @click="checkFun(item1.id,index,'user',item1)">
								<img :src="item1.portrait || imgUrl">
								<p :title="item1.realName">{{item1.realName}}</p>
								<span v-if="item1.txtNum">{{item1.txtNum}}</span>
							</li>
						</ul>
					</template>
					<audio src="./../../static/img/mp3.mp3" ref=audio></audio>
				</div>
			</div>
		</div>
		<div class="addPopleBox" v-show="outerVisible">
			<div class="left">
				<el-input class='input' placeholder="请输入搜索内容" v-model="searchText" clearable></el-input>
				<el-button type="primary" @click='searchXingshi' :disabled='searchPeopleBtn'><i v-show="searchPeopleBtn" class="el-icon-loading"></i>搜索</el-button>
				<div class="innerbox" style="height: 430px;overflow: auto;">
          <template v-if="searchPeople.institutes.length != 0 || searchPeople.products.length != 0">
            <div class="listBox listBox1" v-if="searchPeople.institutes.length != 0">
              <div>
                <p>供应商</p>
              </div>
              <li v-for="(item,index) in searchPeople.institutes">
                <img :src="item.portrait || imgUrl">
                <p>{{item.realName }}</p>
                <i v-if="!item.check" class="el-icon-circle-check" :class="{yellow:item.check}" @click="addUser(item,'gys')"></i>
                <i v-else class="el-icon-circle-check" :class="{yellow:item.check}"></i>
              </li>
            </div>
            <div class="listBox listBox1" v-if="searchPeople.products.length != 0">
              <div>
                <p>星使</p>
              </div>
              <li v-for="(item,index) in searchPeople.products">
                <img :src="item.portrait || imgUrl">
                <p>{{item.realName }}</p>
                <i v-if="!item.check" class="el-icon-circle-check" :class="{yellow:item.check}" @click="addUser(item,'xingshi')"></i>
                <i v-else class="el-icon-circle-check" :class="{yellow:item.check}"></i>
              </li>
            </div>
          </template>
          <p v-if="searchPeople.institutes.length == 0 && searchPeople.products.length == 0 && searchPeopleBtn1" style="text-align: center;color: #999;margin-top: 20px;">暂未搜索到，请重试！</p>
				</div>
			</div>
			<div class="right border">
				<p>请勾选需要添加的联系人({{addUserList.length}})</p>
				<div class="innerbox" style="height: 380px;overflow: auto;">
					<div class="listBox listBox1" v-for="item in addUserList">
						<li>
							<img :src="item.portrait || imgUrl">
							<p>{{item.realName}}</p>
							<i class="el-icon-circle-close" @click="deleteUser(item)"></i>
						</li>
					</div>
				</div>
			</div>
			<div class="right">
				<i class="el-icon-close" @click="outerVisible=false"></i>
				<p><b>加入到进行中案件</b></p>
				<div class="innerbox addCaseGoingBox" style="height: 380px;overflow: auto;">
					<div class="listBox listBox1" >
						<template v-if="btnAddPeople">
							<li v-for="(item,index) in nowCaseArr" v-if="item.obj.obj.id == addCaseGoingId">
								<p>{{item.obj.obj.reportUser}}</p>
								<i class="el-icon-circle-check" :class="{yellow:addCaseGoingIndex === index}" @click="addCaseGoingFun(item.obj.obj.id,index)"></i>
							</li>
						</template>
						<template v-else>
							<li v-for="(item,index) in nowCaseArr">
								<p>{{item.obj.obj.reportUser}}</p>
								<i class="el-icon-circle-check" :class="{yellow:addCaseGoingIndex === index}" @click="addCaseGoingFun(item.obj.obj.id,index)"></i>
							</li>
						</template>
					</div>
				</div>
				<div class="btn">
					<button type="button" @click="addUserToCase">添加</button>
					<button type="button" @click="outerVisible=false">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import langtrans from "./js/workbench.vue.trans.js";
	import dialogBox from './dialog'
	import voiceBox from './voice'
	import {
    gethistoryCaseMsg,
    getCaseConnectedIMGroups,
    matchProvidersByKey,
    getallGoingCase,
    getnowCase,
    getnowCaseRegulator,
    addContactsCase,
    getAllCoordinatedCases
  } from '@/views/axios/api.js';
	export default{
		data(){
			return {
				msg:'',
				userList:[],
				outerVisible:false,
				token:JSON.parse(window.localStorage.getItem("data")).data,
				sendId:JSON.parse(window.localStorage.getItem("sendId")),
				insti:JSON.parse(window.localStorage.getItem("insti")),
        typeUserId:JSON.parse(window.localStorage.getItem("insti")).type,
				messageText:'',
				messageList:[],//聊天列表
				websock:null,
				xsjrBtn:true,//是否已经有星使了
				searchText:'',
				getUserData:[],
				getZhzxData:[],
				addUserList:[],
				caseUserId:'',
				caseUserIndex:'',
				searchPeople:{
					products:[],
					institutes:[]
				},
				searchPeopleBtn:false,
				searchPeopleBtn1:false,
				isGroup:false,
				nowCaseArr:[],
				addCaseGoingIndex:'',
				addCaseGoingId:'',
				unReadNum:0,
				unReadNumList:[],
				addGroupId:'',
				checkGroupCreate:false,
				checkGroupCreateIndex:0,
				loading:false,
				imgUrl:require("@/views/commonPage/img/moren.png"),
				imgUrl1:require("@/views/commonPage/img/qun1.png"),
				localStoragePeople:[],
				dataPeople:{
					typeUser:'',
				},
				btnAddPeople:false
			}
		},
		components:{
			dialogBox,
			voiceBox
		},
		mounted(){
			// this.getCaseConnectedIMGroups();
			this.getnowCase();
			if(JSON.parse(localStorage.getItem('people'))){
				this.localStoragePeople=JSON.parse(localStorage.getItem('people'))
			}
			var timer=null

			// 仅【测试环境】监管机构跳过 WebSocket：
			// 测试 WS（rescueim）可能未对监管机构开放，会立即断开并触发反复弹窗；正式环境保留原逻辑
			var isTestEnv = window.SEVSRS && String(window.SEVSRS).includes('test');
			var isRegulator = this.$route.path.indexOf('/regulator') !== -1;
			try {
				var usertype = JSON.parse(window.localStorage.getItem('usertype') || '{}').data;
				if (usertype === 2) isRegulator = true;
			} catch (e) {}
			if (!(isTestEnv && isRegulator)) {
				if(this.$store.state.websock == null){
					timer=setInterval(()=>{
						this.$store.commit('websockStore',this.token)
						this.websock=this.$store.state.websock;
						if(this.websock){
							clearInterval(timer)
							this.websock.onmessage = this.websocketonmessage;
						}
					},500)
				}else{
					this.websock=this.$store.state.websock
				}
			}
			//拖拽
			var dev =this.$refs.workBox;
			var devTop =this.$refs.workBoxTop;
			devTop.onmousedown=function(){
				//event的兼容性
				var ev = ev||event;
				//获取鼠标按下的坐标
				var x1 = ev.clientX;
				var y1 = ev.clientY;
				//获取元素的left，top值
				var l = dev.offsetLeft;
				var t = dev.offsetTop;
				document.onmousemove=function(ev){
					//event的兼容性
					var ev = ev||event;

					//获取鼠标移动时的坐标
					var x2 = ev.clientX;
					var y2 = ev.clientY;

					//计算出鼠标的移动距离
					var x = x2-x1;
					var y = y2-y1;

					//移动的数值与元素的left，top相加，得出元素的移动的距离
					var lt = y+t;
					var ls = x+l;
					//更改元素的left，top值
					dev.style.margin=0;
					dev.style.top = lt+'px';
					dev.style.left = ls+'px';
				}
			}
			document.onmouseup=function(){
				document.onmousemove=null
			}

		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			},
			nowCaseItem(){
				return this.$store.state.nowCaseItem;
			}
		},
		methods:{
			langtrans(){
				return langtrans
			},
			fuzhi(){
				this.websock=this.$store.state.websock;
			},
			init(){
			    this.websock.onmessage = this.websocketonmessage;
			},
			checkGroupCreateFun(data,caseId){
				this.checkGroupCreateIndex++
				var promise=new Promise((reject,resove)=>{
					if(data.caseId == caseId){
						reject({status:'ok',data:data})
					}
					if(this.checkGroupCreateIndex >= 10){
						reject({status:'no'})
					}
				})
				return promise
			},
		  	websocketonmessage(e){ //数据接收
		    	var data=JSON.parse(e.data)
				if(this.checkGroupCreate){//创建群
					this.checkGroupCreateFun(data,this.addCaseGoingId).then(res=>{
						if(res.status == 'ok'){
							this.$message.success('创建成功！')
							this.getUserData.forEach(item => {
								if(item.rescueCase.id == res.data.caseId){
									var data={
										groupId:res.data.groupId,
										name:res.data.groupId
									}
									item.imGroups.push(data)
								}
							})
						}else{
							this.$message.success('创建失败！')
						}
						this.checkGroupCreate=false;
						this.loading=false
					})
				}
				if(this.isGroup){
					var ifMeBtn=false;
					if(data.type == 'user'){
						this.userList=data.data.users;
						this.userList.forEach(item=>{
							if(item.id == this.sendId){
								ifMeBtn=true
							}
						})
						if(!ifMeBtn){
							this.messageList=[]
							// return this.$message.warning('您当前不在这个群聊天中，请点击“添加联系人”')
							var r=confirm('您不在当前群，请点击“确定”添加到此群中');
							if(r){
								var data={
									groupId:this.addGroupId,
									userIds:this.sendId,
									type:'user',
									actType:2
								}
								this.websock.send(JSON.stringify(data))
								this.websocketSendGroupId(this.addGroupId)
							}else{
								console.log(2)
							}
							return
						}
						this.gethistoryCaseMsg();
					}
				}
				if(data.type == 'message'){
          this.$store.commit('websockListFun',data)
          console.log(this.$store.state.websockList);
					var _this=this
					var id =data.data.sendId;
					var recvId =data.data.recvId;
					var groupId =data.groupId;
					if(this.caseUserId == ''){
						return wjxx()
					}else if(groupId){
						if(this.caseUserId != groupId){
							return wjxx()
						}
					}else{
						if(this.caseUserId != id){//等于空
							return wjxx()
						}
					}
					function wjxx(){
						var bTn=true
						_this.getUserData.forEach(item1 => {
							if(groupId != null){
								if(item1.imGroups.length != 0){
									item1.imGroups.forEach((item3,index) => {
										if(item3.groupId === groupId && bTn ){
											++item3.txtNum
											_this.$forceUpdate()
										}
									})
								}
							}else{
								item1.users.forEach((item2,index) => {
									if(item2.id === id && bTn){
										++item2.txtNum;
										_this.$forceUpdate()
									}
								})
							}
						})
						_this.getZhzxData.forEach(item3 => {
							if(groupId == null){
								if(item3.id == id){
									item3.txtNum++;
									_this.$forceUpdate()
								}
							}
						})
					}
					this.messageList.push(data);//接收消息用
					this.messageList.forEach( item => {//判断是谁发的
						if(item.data.sendId == this.sendId){
							item.data.who = 'myself'
						}else{
							item.data.who = 'himself'
						}
					})
					for(let i=0;i<this.getUserData.length;i++){
						if(this.getUserData[i].users.length != 0){
							for(let j=0;j<this.getUserData[i].users.length;j++){
								this.messageList.forEach( item => {
									if(item.data.sendId == this.getUserData[i].users[j].id){
										return item.data.name = this.getUserData[i].users[j].realName
									}
								})
							}
						}
					}
					for(let aa=0;aa<this.getZhzxData.length;aa++){
						this.messageList.forEach( item => {
							if(item.data.sendId == this.getZhzxData[aa].id){
								return item.data.name = this.getZhzxData[aa].realName
							}
						})
					}
					this.scrollFun();
					this.$refs.audio.play()
				}
		 	},
		  	websocketSendText(){//发送文本
		  		var dates=new Date()
		  		if(this.messageText == '') return this.$message.error('发送内容不能为空');
				if(this.caseUserId == '') return this.$message.error('请选择要发送的对象');
				//最近联系人
				this.contactPeople(this.dataPeople)
		  		var data={
		  			type:'message',
		  			actType:1,
		  			data:{
		  				message:{
		  					content:this.messageText
		  				}
		  			}
		  		}
				if(this.isGroup){
					data.groupId=this.caseUserId
				}else{
					data.toId=this.caseUserId
				}
		  		var myData={
					len: null,
					picUrl: null,
					ration: null,
					url: null,
					myself:1,
		  			type:'message',
		  			actType:1,
		  			data:{
		  				message:{
		  					content:this.messageText
		  				},
		  				sendId: this.sendId,
		  				who:'myself',
		  				name:this.insti.name
		  			},
		  			sendTime:dates
		  		}
		  		this.messageList.push(myData)
		  		this.websock.send(JSON.stringify(data))
		  		this.messageText='';
		  		this.scrollFun()//滚动到底部
		  	},
			contactPeople(data){
				var bTn=true;
				if(!this.isGroup){
					this.localStoragePeople.forEach(item => {
						if(item.id == data.id){
							bTn=false
						}
					})
				}else{
					this.localStoragePeople.forEach(item => {
						if(item.groupId == data.groupId){
							bTn=false
						}
					})
				}

				if(bTn) {
					localStorage.removeItem('people');
					this.localStoragePeople.push({name:data.realName,id:data.id,portrait:data.portrait,groupId:data.groupId,typeUser:data.typeUser});
					localStorage.setItem('people',JSON.stringify(this.localStoragePeople));
				}
				console.log(this.localStoragePeople)
			},
		  	enterFun(e){
				if(e.keyCode == '13'){
					this.websocketSendText();
				}
			},
			gethistoryCaseMsg(){
				var data={
						token:this.token,
						start:0,
						count:20,
					}
				if(this.isGroup){
					data.groupId=this.caseUserId
				}else{
					data.fromId=this.caseUserId;
					data.toId=this.sendId
				}
				gethistoryCaseMsg(data)
				.then(res=>{
					this.messageList=res.data.obj;
					this.messageList.forEach( (item) => {
						if(item.data.sendId == this.sendId){
							item.data.who = 'myself'
						}else{
							item.data.who = 'himself'
						}
					})
					this.userList.forEach( item => {
						var id=item.id
						this.messageList.forEach( name => {
							if(name.data.sendId == id){
								name.data.name = item.name
							}
						})
					})
					this.scrollFun()
				})
				.catch(err=>{
					console.log(err)
				})
			},
			scrollFun(){
				this.$nextTick(()=>{
					this.$refs.messageBox.scrollTop = this.$refs.messageBox.scrollHeight;
				})
			},
			timeFormatting(time){
				var dateTime =new Date(time);
				var mouth =dateTime.getMonth() < 9 ? '0' +(dateTime.getMonth()+1):dateTime.getMonth()+1
				var days =dateTime.getDate() < 10 ? '0' +dateTime.getDate():dateTime.getDate();
				var hours=dateTime.getHours() < 10 ? '0' +dateTime.getHours():dateTime.getHours();
				var minutes=dateTime.getMinutes() < 10 ? '0' +dateTime.getMinutes():dateTime.getMinutes();
				return `${mouth} / ${days}  ${hours}:${minutes}`
			},
			closeFun(){
				this.$store.commit('workBtnFun',false);
			},
			imgFun(url){
				this.$store.commit('workImgBoxFun',{url,status:true})
			},
			getCaseConnectedIMGroups(){
        this.loading=true;
				getCaseConnectedIMGroups({token:this.token})
				.then(res => {
					console.log(res)
          this.loading=false
					this.getUserData=res.data.obj;
					this.getZhzxData=res.data.obj2;
					this.getUserData.forEach(item => {
						item.users.forEach(item1 => {
							item1.txtNum=0
						})
						item.imGroups.forEach(item2 => {
							item2.txtNum=0
						})
					})
					this.getZhzxData.forEach(item => {
						item.txtNum=0
					})

          //点击加入协调默认选中状态
          this.getUserData.forEach((item,index)=> {
            if(item.rescueCase.id == this.$store.state.caseId){
              console.log(item);
              this.checkFun(item.imGroups[0].groupId,index,'group',item)
            }
          })
				})
				.catch(err => {
					console.log(err)
				})
			},
			addUser(data,name){
        console.log(data);
				if(name == 'gys'){
					this.searchPeople.institutes.forEach((item,index) => {
						if(item.id == data.id){
							item.check=true;
							item.status=1;//1供应商，2星使
							this.addUserList.push(data)
						}
					})
				}else{
					this.searchPeople.products.forEach((item,index) => {
						if(item.id == data.id){
							item.check=true;
							item.status=2;//1供应商2，星使
							this.addUserList.push(data)
						}
					})
				}

			},
			deleteUser(data){
				this.addUserList.forEach((item,index) => {
					if(data.id == item.id){
						if(data.status == 1){
							this.searchPeople.institutes.forEach(item2 => {
								if(item2.id == data.id){
									item2.check=false;
								}
							})
						}else{
							this.searchPeople.products.forEach(item2 => {
								if(item2.id == data.id){
									item2.check=false;
								}
							})
						}
						this.addUserList.splice(index,1);
					}
				})

			},
			searchXingshi(){
				if(this.searchText == '') return this.$message.warning('请输入搜索内容')
				this.searchPeopleBtn=true;
				this.searchPeopleBtn1=true;
				var data={
					token:this.token,
					key:this.searchText
				}
				matchProvidersByKey(data)
				.then(res => {
					console.log(res)
					this.searchPeopleBtn=false;
					this.searchPeople=res.data.obj;
				})
				.catch(err => {
					console.log(err)
				})
			},
			getnowCase(){//当前案件管理
				var _this=this
				var data={
			        token:this.token
				}
        this.loading=true;
				function routename(){
					if(_this.$route.name == 'mainPase'){
						return getnowCase(data)
					}else if(_this.$route.name == 'mainPaseRegulator'){
						return getnowCaseRegulator(data)
					}else if(_this.typeUserId == 4 || _this.typeUserId == 5){
						  return getAllCoordinatedCases(data)
					} else if(_this.typeUserId == 1){//指挥中心
						// return getallGoingCase(data)
					}
				}
				routename()
				.then(res=>{
          if(this.typeUserId != 1){
            this.nowCaseArr=res.data.obj
          }else{
            res.data.obj.forEach( item => {
              this.nowCaseArr.push(item[0])
            })
          }
          this.loading=false
				})
				.catch(err=>{
					console.log(err)
				})
			},
			addCaseGoingFun(id,index){
				this.addCaseGoingId=id;
				this.addCaseGoingIndex=index;
			},
			checkFun(id,index,name,data){
				if(data){
					this.dataPeople={id:data.id,name:data.realName,portrait:data.portrait,realName:data.realName}
				}
				this.caseUserId =id;
				this.caseUserIndex = index;
				if(name == 'user'){
					this.isGroup=false;
					this.gethistoryCaseMsg();
					this.dataPeople.typeUser='user'
				}else{
					this.isGroup=true;
					this.addGroupId=id;
					this.websocketSendGroupId(id)
					this.dataPeople.typeUser='group'
					this.dataPeople.realName=id
				}
				// this.websock.onmessage = this.websocketonmessage;

				// start 清除未读脚标
					this.getUserData.forEach(item1 => {
						if(item1.imGroups.length != 0){
							item1.imGroups.forEach(item3 => {
								if(item3.groupId === this.caseUserId){
									item3.txtNum=0;
									this.$forceUpdate()
								}
							})
						}
						item1.users.forEach(item2 => {
							if(item2.id === this.caseUserId){
								item2.txtNum=0;
								this.$forceUpdate()
							}
						})
					})
					this.getZhzxData.forEach(item3 => {
						if(!this.isGroup){
							if(item3.id == this.caseUserId){
								item3.txtNum=0;
								this.$forceUpdate()
							}
						}
					})
				//END
			},
		  	websocketSendGroupId(id){//获取人员列表
		  		var data={
		  			groupId:id,
		  			type:'user',
		  			actType:1
		  		}
		  		this.websock.send(JSON.stringify(data))
		  	},
			addUserToCase(){
				if(this.addCaseGoingId == '') return this.$message.warning('请选择要加入的案件！')
				var id=''
				this.addUserList.forEach(item => {
					id += item.id+','
				})
				console.log(this.addUserList)
				// id=id.substring(0,id.length-1)
				if(id == '') return this.$message.warning('请选择要加入的联系人！')
				if(!this.btnAddPeople){ //false创建群
					var data={
						caseId:this.addCaseGoingId,
						userIds:id+this.sendId,
						type:'user',
						actType:5
					}
					this.websock.send(JSON.stringify(data))
					this.outerVisible=false;
					this.checkGroupCreate=true;
					this.loading=true
				}else{//添加人
					var data={
						token:this.token,
						caseId:this.addCaseGoingId,
						userIds:id.substring(0,id.length-1)
					}
					addContactsCase(data)
					.then(res => {
						console.log(res)
						if(res.data.code == 0){
							this.$message.success('添加成功！')
							this.getUserData.forEach(item =>{
								if(item.rescueCase.id == this.addCaseGoingId){
									item.users=[...item.users,...this.addUserList]
								}
							})
							this.outerVisible=false;
						}
					})
					.catch(err => {
						console.log(err)
					})
				}

				// this.$message.success('创建成功！')
			},
			creatGroup(id,status){
				this.btnAddPeople=status
				this.nowCaseArr.forEach((item,index) => {
					if(item.obj.obj.id == id){
						this.addCaseGoingFun(id,index)
					}
				})
			}
		},
		watch:{
			outerVisible(){
				if(!this.outerVisible){
					this.searchPeople={
						products:[],
						institutes:[]
					}
          this.searchText='';
          this.searchPeopleBtn1=false;
          this.addUserList=[]
				}
			},
      '$store.state.caseId'(){
        // this.getCaseConnectedIMGroups()
      }
		}
	}
</script>

<style scoped="scoped">
	.workbenchBox{overflow: hidden;border-top: 1px solid #eee;height:700px;background-color: white;}
	.workbenchBox *{box-sizing: border-box;}
	.left{float: left;}
	.right{float: right;}
	.overflow{overflow: hidden;}
	.workbenchBox >.left{width: 75%;border-right: 1px solid #eee;}
	.workbenchBox >.right{width: 25%;background-color: #f3f2f2;height: 100%;}
	.workbenchBox .left .top{overflow: hidden;height: 60px;line-height: 60px;font-size: 14px;padding: 0 40px;background-color: #fbed9f;border-bottom: 1px solid #eee;cursor: move;}
	.workbenchBox .left .top >.left{color: #333;}
	.workbenchBox .left .top >.right{color: #c27506;cursor: pointer;text-align: right;}
	.header_box{height: 500px;overflow-y:auto ;padding: 25px;border-bottom: 1px solid #eee;}
	.messageBox .icon{border-radius: 50%;width: 40px;height: 40px;}
	.messageBox .message{font-size: 14px;margin-left: 20px;width: calc(100% - 60px);}
	.messageBox .message p{line-height: 20px;}
	.messageBox .message p.text2{color: #999;margin-top: 10px;}
	.messageBox li{margin-bottom: 20px;}
	.messageBox li:last-child{margin-bottom: 0;}
	.messageBox .myself p.text1{text-align: right}
	.messageBox .myself p.text2{text-align: right}
	.messageBox .myself .messImg{float: right;}
	.messageBox .myself .message{margin-left: 0;margin-right: 20px;}
	.enterBox{padding: 8px 30px;}
	.enterBox input{height: 40px;padding-left: 20px;border-radius: 3px;font-size: 14px;border: none;background-color: #f9f9f9;width: 75%;outline: none;}
	.enterBox button{height: 40px;border-radius: 3px;background-color: #f8dc40;color: #c27506;font-size: 14px;border:none;margin-left: 5%;width: 15%;cursor: pointer;outline: none;}
	.workbenchBox >.right .top{height: 60px;line-height: 60px;background-color: #fdf6cf;font-size: 14px;text-align: right;padding-right: 20px;cursor: pointer;}
	.listBox li{overflow: hidden;color: #666;font-size: 14px;line-height: 35px;padding: 5px 15px;background-color: white;cursor: pointer;}
	.listBoxHover .listBox li:active{background: #fdf6cf;}
	.listBoxHover .listBox li:hover{background: #fdf6cf;}
	.listBox li *{float: left;}
	.listBox li p{width: calc(100% - 65px);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-left: 10px;}
	.listBox li span{float: left;background: #E6A23C;width: 20px;height: 20px;border-radius: 50%;line-height: 20px;text-align: center;color: white;margin-top: 5px;}
	.listBox li img{width: 35px;height: 35px;border-radius: 50%;}
	.headerBox{height: 639px;overflow-y:auto;}
	.listBox li.active{background-color: #fbed9f;}
	.messImg{width: 200px;border-radius: 3px;margin-top: 10px;cursor: pointer;object-fit: contain;height: 130px;}
	/* 2019-05-09 */
	.listBox >div{padding-top: 5px;padding-left: 20px;padding-bottom: 5px;overflow: hidden;background: #f2f2f2;}
	.listBox >div p{float: left;width:55%;line-height: 35px;height: 30px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
	/* .listBox >div i{float: right;font-size: 20px;cursor: pointer;color: #999;} */
  .iconGroup img{height: 30px;margin: 0 3px;cursor: pointer;}
	.addPopleBox{position: absolute;top:50%;left: 50%;box-shadow: 0 0 20px 1px  rgba(0,0,0,0.2);overflow: hidden;background: white;width: 900px;height: 500px;border-radius: 5px;margin-left: -450px;margin-top: -250px;}
	.addPopleBox .left{width: 33.3%;float: left;border-right: 2px solid #eee;box-sizing: border-box;height: 500px;}
	.addPopleBox .left .input{margin-top: 20px;margin-bottom: 10px;margin-left: 25px;width: calc(100% - 120px);}
	.addPopleBox .right{width: 33.3%;float: left;position: relative;padding: 35px 0px;box-sizing: border-box;}
	.addPopleBox .right.border{border-right: 1px solid #eee;}
	.listBox1 li p{width: calc(100% - 100px);}
	.listBox1 li i{font-size: 20px;float: right;margin-top: 8px;cursor: pointer;}
	.addPopleBox .right .el-icon-close{position: absolute;top: 25px;right: 30px;font-size: 20px;cursor: pointer;}
	.addPopleBox .right >p{color: #666;padding-left: 20px;}
	.right .listBox1 li{padding-left:0 ;padding: 0 20px;}
	.right .listBox1{margin-top: 20px;}
	.btn{text-align: center;}
	.btn button{border: none;background: #f8dc40;padding: 10px 20px;color: #c27506;margin: 0 10px;border-radius: 3px;cursor: pointer;outline: none;}
	.btn button:last-child{background: #f2f2f2;color: #666;}
	.yellow{color: #67C23A;}
	#workbenchBox{position: fixed;width: 1000px;top: 50%;left: 50%;background: white;margin-left: -500px;box-shadow: 0 0 20px 1px  rgba(0,0,0,0.2);margin-top: -350px;}
	.group ul{overflow: hidden;border-bottom: 1px solid #eee;padding-bottom: 5px;padding-top: 10px;margin-left: 20px;}
	.group li{float: left;width: 80px;cursor: pointer;}
	.group li img{display: block;width: 40px;height: 40px;border-radius: 50%;margin: 0 auto;}
	.group li p{text-align: center;font-size: 12px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
	.addCaseGoingBox .listBox li:hover{background: #fdf6cf;}
	.groupCreat{text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
</style>
<style>
	#workbenchBox .el-dialog{margin-top: 10px !important;}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/workbench.vue